import { useMutation } from '@tanstack/react-query';
import { CampaignMedium } from '@prisma/client';
import {
  deleteEmailTemplate,
  deleteSmsTemplate,
} from '../../services/marketing';
import useGetMarketingData from './useGetMarketingData';

interface Options {
  onSuccess?: () => void | Promise<void>;
  onError?: () => void | Promise<void>;
}

function useDeleteTemplate({ onSuccess, onError }: Options = {}) {
  const {
    data: marketingData,
    isFetching: isFetchingMarketing,
    isEnabled,
  } = useGetMarketingData();

  return useMutation({
    mutationFn: async ({
      type,
      templateId,
    }: {
      type: CampaignMedium;
      templateId: number;
    }) => {
      if (!marketingData?.id || isFetchingMarketing || !isEnabled) return null;
      const deleteFunction =
        type === 'EMAIL' ? deleteEmailTemplate : deleteSmsTemplate;
      const result = await deleteFunction(marketingData.id, templateId);
      return result;
    },
    onSuccess: async () => {
      await onSuccess?.();
    },
    onError,
  });
}

export default useDeleteTemplate;
